import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PhxIconModule } from '../icon/icon.module';
import { PhxTagComponent } from './phx-tag.component';
import { PhxTagDisplayComponent } from './tag-display/phx-tag-display.component';
import { PhxTagUpsellComponent } from './tag-upsell/phx-tag-upsell.component';
import { PhxTooltipModule } from '../tooltip/phx-tooltip.module';

@NgModule({
  declarations: [
    PhxTagComponent,
    PhxTagDisplayComponent,
    PhxTagUpsellComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PhxIconModule,
    PhxTooltipModule
  ],
  exports: [
    PhxTagComponent,
    PhxTagDisplayComponent,
    PhxTagUpsellComponent,
  ]
})
export class PhxTagModule { }
